import { apiClient } from "./client";
import type {
  GetYearlyRankings200Response,
  Mypage,
  YearlyRanking,
} from "../types/swagger";
import { mockMypage, mockYearlyRankings } from "../mocks/fixtures/rankings";

export type { GetYearlyRankings200Response, YearlyRanking, Mypage };

const USE_MOCK = process.env.REACT_APP_USE_MOCK === "true";

export const rankingsApi = {
  /** 年間ランキング一覧取得 GET /yearly/rankings */
  getYearly: async (): Promise<GetYearlyRankings200Response> => {
    if (USE_MOCK) {
      return {
        event_group: mockMypage.event_group,
        rankings: mockYearlyRankings,
      };
    }
    const { data } = await apiClient.get<GetYearlyRankings200Response>(
      "/yearly/rankings",
    );
    return data;
  },

  /** マイページ取得 GET /mypage */
  getMyPage: async (): Promise<Mypage> => {
    if (USE_MOCK) {
      return mockMypage;
    }
    const { data } = await apiClient.get<Mypage>("/mypage");
    return data;
  },
};
